// Components
import { Skeleton, Formblock } from '@zolteam/zol-admin-ui';

/**
 * FormSkeleton component
 * @returns {JSX.Element}
 */
function FormSkeleton() {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(12, 1fr)',
      gridGap: '0.5rem',
    }}
    >
      <Formblock htmlFor="loader" style={{ gridArea: '1/1/1/7' }}>
        <Skeleton shape="rectangle" height="3.625rem" width="100%" />
      </Formblock>
      <Formblock htmlFor="loader" style={{ gridArea: '1/7/1/13' }}>
        <Skeleton shape="rectangle" height="3.625rem" width="100%" />
      </Formblock>
      <Formblock htmlFor="loader" style={{ gridArea: '2/1/2/13' }}>
        <Skeleton shape="rectangle" height="3.625rem" width="100%" />
      </Formblock>
      <Formblock htmlFor="loader" style={{ gridArea: '3/1/3/7' }}>
        <Skeleton shape="rectangle" height="3.625rem" width="100%" />
      </Formblock>
      <Formblock htmlFor="loader" style={{ gridArea: '3/7/3/13' }}>
        <Skeleton shape="rectangle" height="3.625rem" width="100%" />
      </Formblock>
      <Formblock htmlFor="loader" style={{ gridArea: '4/1/4/7' }}>
        <Skeleton shape="rectangle" height="3.625rem" width="100%" />
      </Formblock>
      <Formblock htmlFor="loader" style={{ gridArea: '4/7/4/13' }}>
        <Skeleton shape="rectangle" height="3.625rem" width="100%" />
      </Formblock>
      <Formblock htmlFor="loader" style={{ gridArea: '5/1/5/13' }}>
        <Skeleton shape="rectangle" height="3.625rem" width="100%" />
      </Formblock>
      <Formblock htmlFor="loader" style={{ gridArea: '6/1/6/13' }}>
        <Skeleton shape="rectangle" height="3.625rem" width="100%" />
      </Formblock>
    </div>
  );
}

export default FormSkeleton;
